export const PetsOfferMapper = () => {
  const getBasePrice = (offerObject) => Number(offerObject?.price) || 0;

  const getAgentEarnings = (offerObject) => Number(offerObject?.earnings) || 0;

  const getAgentEarningsPercent = (offerObject) => {
    return Number(offerObject?.earnings_param) || 0;
  };

  const getNetPrice = (offerObject) => getBasePrice(offerObject) - getAgentEarnings(offerObject);

  const getInsuranceCompanyPublicDocuments = (offerObject) => {
    return [
      { key: 'product', title: 'Інформація про страховий продукт', url: offerObject?.company?.docProduct },
      { key: 'company', title: 'Інформація про cтрахову компанію', url: offerObject?.company?.docCompany },
      { key: 'agent', title: 'Інформація про страхового посередника', url: offerObject?.company?.docAgent },
      { key: 'zusp', title: 'Інформація про загальні умови страхового продукту', url: offerObject?.company?.docZusp },
    ].filter(item => !!item.url);
  };

  const getInsuranceCompanyCustomOptions = (customOptions) => {
    if (!customOptions || !Array.isArray(customOptions)) return [];
    return customOptions.map(option => ({
      title: option,
      enabled: true,
    }));
  };

  const mapPetsOffer = (offerObject) => {
    return {
      id: offerObject.offerId || offerObject.id || null,
      module: {
        id: offerObject.moduleId || null,
      },
      company: {
        id: offerObject.companyId || null,
        name: offerObject.companyNamePublic || offerObject.companyName || null,
        logo: offerObject.companyLogo || offerObject.company?.logo || null,
        rating: offerObject?.company?.rating || null,
        hasBranch: offerObject?.hasCompanyBranch || null,
        features: [
          { key: 'direct-settlement', title: 'Пряме врегулювання', enabled: offerObject?.company?.directSettlement },
          { key: 'support-everytime', title: 'Допомога 24/7', enabled: offerObject?.company?.supportEverytime },
          { key: 'medicine-help', title: 'Медична допомога', enabled: offerObject?.company?.medicineHelp },
          ...getInsuranceCompanyCustomOptions(offerObject?.company?.customOptions),
        ],
        documents: getInsuranceCompanyPublicDocuments(offerObject),
        description: offerObject?.company?.description || null,
      },
      tariff: {
        program: offerObject?.programmName || null,
      },
      parameters: [],
      pricing: {
        basePrice: getBasePrice(offerObject).toFixed(2),
        finalPrice: getBasePrice(offerObject).toFixed(2),
        netPrice: getNetPrice(offerObject).toFixed(2),
        agentCommission: {
          own: getAgentEarnings(offerObject).toFixed(2),
          ownPercent: getAgentEarningsPercent(offerObject).toFixed(0),
        },
      },
      contract: {
        startDate: offerObject.startFrom || null,
        insurancePeriod: offerObject.insurancePeriod || null,
      },
      earnings: offerObject.earnings || null,
      earningsParam: offerObject.earnings_param ?? null,
      externalIdCompany: offerObject.externalIdCompany || offerObject.ex_id || null,
      externalIdTariff: offerObject.externalIdTariff || offerObject.ex_tariff_id || null,
      documents: {
        allowedTypes: offerObject.available_documents || null,
      },
    };
  };

  const mapPetsOfferFromOrder = (order) => {
    if (!order) return null;

    const offer = order.offer || {};
    const companyInfo = order.companyInfo || {};

    const legacyOfferFormat = {
      offerId: offer.id,
      moduleId: order.moduleId,
      companyId: companyInfo.companyId,
      companyNamePublic: companyInfo.publicName,
      companyName: companyInfo.publicName,
      companyLogo: companyInfo.info?.logo || null,
      price: order.price,
      commission: order.commission || order.earnings,
      startFrom: order.startDate,
      insurancePeriod: offer.insurancePeriod,
      earnings: order.earnings,
      earnings_param: order.earningsParam ?? null,
      externalIdCompany: offer.ex_id,
      externalIdTariff: offer.ex_tariff_id,
      hasCompanyBranch: companyInfo.hasBranch ?? null,
      company: {
        ...companyInfo.info,
        rating: companyInfo.info?.rating || null,
        docProduct: companyInfo.info?.docProduct || null,
        docCompany: companyInfo.info?.docCompany || null,
        docAgent: companyInfo.info?.docAgent || null,
        docZusp: companyInfo.info?.docZusp || null,
        description: companyInfo.info?.description || null,
        directSettlement: companyInfo.info?.directSettlement || null,
        supportEverytime: companyInfo.info?.supportEverytime || null,
        medicineHelp: companyInfo.info?.medicineHelp || null,
        customOptions: companyInfo.info?.customOptions || [],
      },
      programmName: offer.programmName || null,
      available_documents: offer.available_documents ?? offer.allowed_documents ?? null,
    };

    return mapPetsOffer(legacyOfferFormat);
  };

  return {
    mapPetsOffer,
    mapPetsOfferFromOrder,
  };
};
